import React from "react";
import "./BounceIcon.css";

/**
 * Waiting indicator shown while the AI streams a response.
 * The limkc logo doing a 3D Y-axis spin — ported from the mobile Flutter
 * AnimatedChattyLogo (1500ms loop, easeInOutCubic, perspective depth).
 * Renders nothing when not loading.
 */
const BounceIcon = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="w-5 h-5 flex items-center justify-center">
      <img
        src="/limkc-logo.png"
        alt=""
        aria-hidden="true"
        className="w-5 h-5 limkc-logo-spin"
      />
    </div>
  );
};

export default BounceIcon;